import * as CarbonDioxide from 'types/Ingredient/Detail/CarbonDioxide';

export type Type = CarbonDioxide.Type[];

export function create(): Type {
	return [];
}
